import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button } from 'react-bootstrap';
import { useFetchStore } from '../api/account';
import Preloader from '../components/Preloader';

const DesignTool = (props) => {
  const {
    task = '',
    designId,
    productId,
    sideId,
    isAdmin = false,
    onClose,
    goBack,
  } = props;

  let iframeSrc = null;

  const designToolUrl = process.env.REACT_APP_DESIGN_TOOL_URL;

  const { data, isLoading } = useFetchStore();

  if (data) {
    const token = data.unauth_token;

    // const url = new URL(window.location.href);
    // const productId = url.searchParams.get('product_id');
    // const sideId = url.searchParams.get('side_id');
    // const isAdmin = url.searchParams.get('is_admin');
    // const templateId = url.searchParams.get('template_id');

    iframeSrc = `${designToolUrl}?api_key=${token}&product_id=${productId}`;
    if (sideId) {
      iframeSrc += `&side_id=${sideId}`;
    }

    if (designId) {
      if (task === 'edit_template' || task === 'create_template') {
        iframeSrc += `&template_id=${designId}`;
      } else if (task === 'edit') {
        iframeSrc += `&design_id=${designId}`;
      }
    }
    if (task) {
      iframeSrc += `&task=${task}`;
    }
    if (isAdmin) {
      iframeSrc += '&is_admin=1';
    }
  }

  if (isLoading) {
    return <Preloader isFullHeight />;
  }

  return (
    <div className="design-tool-area" style={{ height: '100vh' }}>
      {data && (
        <>
          <div className="close-iframe-design bg-white left-1">
            {(onClose || goBack) && (
              <Button variant="link" onClick={onClose || goBack}>
                <FontAwesomeIcon icon={faTimesCircle} color="#f00" size="2x" />
              </Button>
            )}
          </div>
          <iframe src={iframeSrc} title="createTemplate" className="w-100 h-100">
            Create Template
          </iframe>
        </>
      )}
    </div>
  );
};

export default DesignTool;
